export default class {
  /**
   * @constructor
   */
  public constructor() {
    this.initSectionWave()
    this.initDividerWave()
    this.initResponsiveTable()
    this.initScrollEvent()
    this.initFace()
    this.initTableOfContents()
    this.togglePagelink()
    this.toggleCollapse()
  }

  /**
   * @returns {void}
   */
  protected initDividerWave(): void {
    document
      .querySelectorAll(".divider-wave-top, .divider-wave-bottom")
      .forEach((element: HTMLElement) => {
        this.prependChidren(["left", "right"], element)
      })
  }

  /**
   * @returns {void}
   */
  protected initSectionWave(): void {
    document
      .querySelectorAll(".section-wave")
      .forEach((element: HTMLElement) => {
        this.prependChidren(
          ["top-left", "top-right", "bottom-left", "bottom-right"],
          element
        )
      })
  }

  /**
   * @returns {void}
   */
  protected initResponsiveTable(): void {
    document
      .querySelectorAll(".table-responsive > table")
      .forEach((element: HTMLTableElement) => {
        element.classList.add("table")
      })
  }

  /**
   * @returns {void}
   */
  protected initScrollEvent(): void {
    const position: number = document.querySelector("header").offsetHeight
    const footerFace: HTMLElement = document.getElementById("footer-face")
    const targets: HTMLElement[] = [
      document.getElementById("header-fixed"),
      footerFace,
    ]
    this.clickScrollTopEvent(footerFace)
    this.toggleScrollEvent(position, targets)
    window.addEventListener("scroll", () => {
      this.toggleScrollEvent(position, targets)
    })
  }

  /**
   * @returns {void}
   */
  protected initFace(): void {
    document.querySelectorAll(".face").forEach((face: HTMLElement) => {
      this.prependChidren(["left", "right"], face)
      this.clickFaceEvent(face)
    })
  }

  /**
   * @returns {void}
   */
  protected initTableOfContents(): void {
    const toc: HTMLElement | null = document.getElementById("table-of-contents")
    if (window.innerWidth < 1300 && toc) {
      toc.classList.add("d-none")
    }
  }

  /**
   * @returns {void}
   */
  protected toggleCollapse(): void {
    document
      .querySelectorAll('[data-toggle="collapse"]')
      .forEach((button: HTMLElement) => {
        const nav: HTMLElement = document.querySelector(button.dataset.target)
        if (button.dataset.default !== "show" && window.innerWidth <= 767) {
          nav.classList.add("d-none")
        }
        button.addEventListener("click", (event: MouseEvent) => {
          nav.classList.toggle("d-none")
        })
      })
  }

  /**
   * @returns {void}
   */
  protected togglePagelink(): void {
    document
      .querySelectorAll('[data-toggle="pagelink"]')
      .forEach((button: HTMLElement) => {
        this.clickPagelinkEvent(button)
      })
  }

  /**
   * ------------------------------------
   * @access private
   * ------------------------------------
   */

  /**
   * @param string[] classList
   * @param HTMLElement parent
   * @param string tag = "span"
   * @returns {HTMLElement}
   */
  private prependChidren(
    classList: string[],
    parent: HTMLElement,
    tag: string = "span"
  ): HTMLElement {
    classList.forEach((name) => {
      const child = document.createElement(tag)
      child.classList.add(name)
      parent.prepend(child)
    })
    return parent
  }

  /**
   * @param number position
   * @param HTMLElement[] targets
   * @returns {void}
   */
  private toggleScrollEvent(position: number, targets: HTMLElement[]): void {
    targets.forEach((target: HTMLElement) => {
      if (position + 50 < window.scrollY) {
        target.classList.remove("hidden")
        target.style.setProperty("opacity", "1")
      }
      if (position > window.scrollY) {
        target.classList.add("hidden")
      }
    })
  }

  /**
   * @param HTMLElement element
   * @returns {HTMLElement}
   */
  private clickScrollTopEvent(element: HTMLElement): HTMLElement {
    element.addEventListener("click", (event: MouseEvent) => {
      window.scrollTo(0, 0)
    })
    return element
  }

  /**
   * @param HTMLElement face
   * @returns {HTMLElement}
   */
  private clickFaceEvent(face: HTMLElement): HTMLElement {
    face.addEventListener("click", (event: MouseEvent) => {
      if (!face.classList.contains("pain")) {
        face.classList.add("pain")
        window.setTimeout(() => {
          face.classList.remove("pain")
        }, 2500)
      }
    })
    return face
  }

  /**
   * @param HTMLElement button
   * @returns {void}
   */
  private clickPagelinkEvent(button: HTMLElement): void {
    const target: HTMLElement | null = document.querySelector(
      button.dataset.target
    )
    if (!target) {
      return
    }
    const diff: number =
      document.getElementById("header-fixed").clientHeight + 24
    button.addEventListener("click", (event: MouseEvent) => {
      window.scrollBy(0, target.getBoundingClientRect().top - diff)
    })
  }
}
